/* eslint-disable */
import Vue from 'vue';
import { Consts, Http, UploadService, } from 'sr-js-lib';

// ------------------------------------------- Start Customer Services ----------------------------
const VUE_APP_API_CUSTOMER = process.env.VUE_APP_API_CUSTOMER;

export const validateCustomerAddress = (storeId, body) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/${storeId}/validate/address`,
    method: 'post',
    body,
    showError: false,
    errorList: {
      '43': Consts.Context.APP.$t('general.invalidAddressDelivery'),
    },
  })
);

export const login = ({ phone, password }) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/auth`,
    method: 'post',
    body: { phone, password },
    showError: true,
    errorList: { 
      '1': Consts.Context.APP.$t('notify_messages.invalidCredentials'),
      '12': Consts.Context.APP.$t('notify_messages.accountNotValidated'),
    },
  })
);

export const signup = (body) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/signup`,
    method: 'post',
    body,
    showError: true,
    errorList: { 
      '107': Consts.Context.APP.$t('notify_messages.existingAccount'), 
      '108': Consts.Context.APP.$t('notify_messages.accountNotValidated'), 
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('notify_messages.pinSent'),
    });
    return response;
  })
);

export const resendPin = (phone) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/${phone}/resend`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('notify_messages.pinSent'),
    });
    return response;
  })
);
export const validatePin = (phoneData) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/validate`,
    method: 'put',
    body: phoneData,
    showError: true,
    errorList: { 
      '11': Consts.Context.APP.$t('notify_messages.incorrectPin'), 
      '107': Consts.Context.APP.$t('notify_messages.existingAccount'), 
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('notify_messages.pinValidated'),
    });
    return response;
  })
);


export const forgotPassword = (phone) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/forgot-password`,
    method: 'post',
    body: { phone },
    showError: true,
    errorList: {
      '20': Consts.Context.APP.$t('notify_messages.accountNotFound'), 
      '12': Consts.Context.APP.$t('notify_messages.accountNotValidated'), 
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('notify_messages.pinSent'),
    });
    return response;
  })
);

export const recoverPassword = ({phone,password,token}) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/recover-password`,
    method: 'post',
    body: { phone,password,token },
    showError: true,
    errorList: { 
      '11': Consts.Context.APP.$t('notify_messages.incorrectPin'), 
      '20': Consts.Context.APP.$t('notify_messages.accountNotFound'), 
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('notify_messages.passwordUpdated'),
    });
    return response;
  })
);

export const getMe = () => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/me`,
    method: 'get',
    body: {},
    showError: true,
    errorList: {},
  })
);

export const updateUser = (body) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/me`,
    method: 'put',
    body: body,
    showError: true,
    errorList: { 
      '105': Consts.Context.APP.$t('notify_messages.existingEmail'), 
      '107': Consts.Context.APP.$t('notify_messages.existingAccount'), 
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('notify_messages.profileUpdated'),
    });
    return response;
  })
);

export const updateUserAddress = (body) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/me/address`,
    method: 'put',
    body: body,
    showError: true,
    errorList: { 
      '43': Consts.Context.APP.$t('notify_messages.invalidDeliveryZipCode'), 
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('notify_messages.addessUpdated'),
    });
    return response;
  })
);

export const changePassword = (body) => (
  Http({
    url: `${VUE_APP_API_CUSTOMER}/change-password`,
    method: 'post',
    body: body,
    showError: true,
    errorList: { 
      '1': Consts.Context.APP.$t('notify_messages.invalidCredentials'), 
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('notify_messages.passwordUpdated'),
    });
    return response;
  })
);


// ------------------------------------------- END Customer Services ----------------------------

// ------------------------------------------- Start Products Services ----------------------------

const VUE_APP_API_PRODUCT = process.env.VUE_APP_API_PRODUCT;

export const getStores = () => (
  Http({
    url: `${VUE_APP_API_PRODUCT}/store`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getStoreProducts = (store_id) => (
  Http({
    url: `${VUE_APP_API_PRODUCT}/bystore/${store_id}/home`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getStoreCategorys = () => (
  Http({
    url: `${VUE_APP_API_PRODUCT}/category`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);


export const getProductsByCategory = (store_id, categoryId, page, qty) => (
  Http({
    url: `${VUE_APP_API_PRODUCT}/bystore/${store_id}/bycategory/${categoryId}?page=${page}&qty=${qty}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);
export const getProductsBySubcategory = (store_id, categoryId, subcategoryId) => (
  Http({
    url: `${VUE_APP_API_PRODUCT}/bystore/${store_id}/bycategory/${categoryId}/bysubcategory/${subcategoryId}?page=${page}&qty=${qty}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);
export const getProductsPromotions = (store_id, page, qty) => (
  Http({
    url: `${VUE_APP_API_PRODUCT}/bystore/${store_id}/promotions?page=${page}&qty=${qty}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getBanner = () => (
  Http({
    url: `${VUE_APP_API_PRODUCT}/banner`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);
export const getProducts = (store_id, keys,categoryId) => (
  Http({
    url: `${VUE_APP_API_PRODUCT}/bystore/${store_id}/search/${keys}${ categoryId ? ('?category_id=' + categoryId) : '' }`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);
// ------------------------------------------- END Products Services ----------------------------


// ------------------------------------------- Start Order Services ----------------------------

const VUE_APP_API_ORDER = process.env.VUE_APP_API_ORDER;

export const addProduct = (productId,body) => (
  Http({
    url: `${VUE_APP_API_ORDER}/cart/product/${productId}/add`,
    method: 'put',
    body: body,
    showError: true,
    errorList: {},
  })
);
export const updateProduct = (productId,body) => (
  Http({
    url: `${VUE_APP_API_ORDER}/cart/product/${productId}/update`,
    method: 'put',
    body: body,
    showError: true,
    errorList: {},
  })
);
export const deleteProduct = (productId,body) => (
  Http({
    url: `${VUE_APP_API_ORDER}/cart/product/${productId}`,
    method: 'delete',
    body: body,
    showError: true,
    errorList: {},
  })
);

export const transferCart = (token, params) => (
  Http({
    url: `${VUE_APP_API_ORDER}/cart/bytoken/${token}/transfer`,
    method: 'post',
    body: params,
    showError: false,
    errorList: {},
  })
);

export const getCart = () => (
  Http({
    url: `${VUE_APP_API_ORDER}/mycart`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);
export const setCart = (cartId) => (
  Http({
    url: `${VUE_APP_API_ORDER}/cart/${cartId}/tocustomer`,
    method: 'put',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getCartByToken = (token) => (
  Http({
    url: `${VUE_APP_API_ORDER}/cart/bytoken/${token}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getDeliveryMethods = (orderId) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/deliverymethods`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getPaymentMethods = (orderId) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/paymentmethods`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const setPaymentMethod = (orderId, body) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/paymentmethod`,
    method: 'put',
    body: body,
    showError: true,
    errorList: {},
  })
);

export const setDeliveryMethod = (orderId, body) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/deliverymethod`,
    method: 'put',
    body: body,
    showError: false,
    errorList: {},
  })
);

export const setDeliveryTime = (orderId, body) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/deliverytime`,
    method: 'put',
    body: body,
    showError: true,
    errorList: {},
  })
);

export const getMyOrder = () => (
  Http({
    url: `${VUE_APP_API_ORDER}/myorder`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);


export const confirmOrder = (orderId,notes) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/confirm`,
    method: 'put',
    body: notes ? notes : null,
    showError: true,
    errorList: {},
  })
);

export const getMyOrders = (dateRange) => (
  Http({
    url: `${VUE_APP_API_ORDER}/myhistory?until=${dateRange}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);
export const deleteOrder = (orderId,cancelation_notes) => (
  Http({
    url: `${VUE_APP_API_ORDER}/myorder/${orderId}`,
    method: 'delete',
    body: {cancelation_notes},
    showError: true,
    errorList: {},
  })
);

export const setPreviousOrder = (orderId) => (
  Http({
    url: `${VUE_APP_API_ORDER}/myorder/${orderId}/tocart`,
    method: 'post',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const updateOrderReview = (orderId,body) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/review`,
    method: 'put',
    body,
    showError: false,
    errorList: {},
  })
);

export const addCoupon = (orderId, params) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/coupon`,
    method: 'post',
    body: params,
    showError: true,
    errorList: {
      '43': Consts.Context.APP.$t('general.invalidCoupon'),
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('general.couponApplied'),
    });
    return response;
  })
);

export const removeCoupon = (orderId) => (
  Http({
    url: `${VUE_APP_API_ORDER}/${orderId}/coupon`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('general.couponRemoved'),
    });
    return response;
  })
);
export const getAvailableCoupons = (store_id) => (
  Http({
    url: `${VUE_APP_API_ORDER}/coupon/available/${store_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);
// ------------------------------------------- END Order Services ----------------------------


